// Whether the current session holds an admin-set password the user must replace before using the
// app. It rides alongside the access token (same in-memory, bundle-scoped lifetime): the API reports
// it on every login and refresh, so a reload re-derives it rather than trusting a stored copy.
//
// This is routing, not enforcement. The API refuses a flagged session on every endpoint but the
// change itself (403 `password_change_required`), so the app cannot be reached by clearing this flag
// — and a session flagged after login is caught by authProvider.onError raising it from that 403.
//
// Unlike the token this has subscribers, because the app shell has to re-render into (and out of) the
// forced-change screen the moment the flag flips.
let mustChange = false;
const listeners = new Set<() => void>();

export function getMustChangePassword(): boolean {
  return mustChange;
}

export function setMustChangePassword(value: boolean): void {
  if (mustChange === value) return;
  mustChange = value;
  listeners.forEach((listener) => listener());
}

/** Subscribe to changes; returns the unsubscribe. Shaped for React's useSyncExternalStore. */
export function subscribeMustChangePassword(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
